import React, {useState} from "react";
import { connect } from "react-redux";

import {getCurrentLayout} from "../../appLayout";
import RoomSceneNavigationItem from "./roomSceneNavigationItem";
import {getAvailableRoomScenes} from "./navUtils";

const RoomSceneNavigation = () => {

  const layout = getCurrentLayout();
  const [activeScene, setActiveScene] = useState(layout.scene);

  const availableRoomScenes = getAvailableRoomScenes();
  // console.log("availableRoomScenes", availableRoomScenes);

  return (
    <div className='layout'>
      <ul className="layout-list">
        {availableRoomScenes.map(roomScene => {
          return <RoomSceneNavigationItem roomScene={roomScene}
                                          key={roomScene}
                                          isActive={activeScene === roomScene}
                                          setActiveScene={setActiveScene} />
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RoomSceneNavigation)
